import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

import "core-js/fn/symbol/iterator";
import "core-js/fn/symbol";
import 'core-js/es6/number';

ReactDOM.render(<App />, document.getElementById('af-container'));



// WEBPACK FOOTER //
// ./src/index.js